import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { styled } from "@mui/material";
var StyledCircle = styled("div")(function (_a) {
    var colors = _a.colors;
    return ({
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: colors ? colors === null || colors === void 0 ? void 0 : colors.backgroundColor : "var(--grey-color-400)",
        border: colors ? "1px solid #00213620" : "1px solid #00213620",
    });
});
var CircleComponent = function (_a) {
    var colors = _a.colors;
    return _jsx(StyledCircle, { colors: colors });
};
export default CircleComponent;
